import React from 'react';
import PropTypes from 'prop-types';
import {
	Box,
	Tabs,
	Tab,
	Chip,
	Tooltip,
	Badge,
	IconButton
} from '@mui/material';
import FilterListIcon from '@mui/icons-material/FilterList';
import { GREEN } from '../../Assets/Constants/theme.js';
import DownloadIcon from '../../Assets/Images/svgs/download.svg';
import RenderMenu from './MenuDropdown/render-menu.js';
import CustomDropdown from './custom-dropdown.js';

const TabHeader = ({
	isMobile,
	tabs,
	selectedTab,
	handleTabChange,
	documentCounts,
	countMappingNames,
	selectedDropdownValue,
	handleDropdownChange,
	startDate,
	endDate,
	statusFilter,
	handleFilterClick,
	handleDownloadModal,
	downloadAnchor,
	open,
	handleClose,
	itemMenu,
	dropdowns
}) => (
	<Box
		sx={{
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'space-between',
			flexWrap: isMobile ? 'wrap' : 'unset',
			borderBottom: '1px solid #e0e0e0',
			gap: 2,
			mt: 2
		}}
	>
		{/* Tabs */}
		<Tabs
			value={selectedTab}
			onChange={handleTabChange}
			variant='scrollable'
			scrollButtons='auto'
			sx={{
				flexGrow: 1,
				minWidth: 0,
				'& .MuiTab-root': {
					minHeight: '72px',
					px: 3,
					py: 2,
					fontSize: '1rem',
					fontWeight: 600,
					textTransform: 'none',
					color: '#0A0909'
				},
				'& .MuiTab-root.Mui-selected': {
					color: '#21241E'
				}
			}}
			slotProps={{
				indicator: { sx: { backgroundColor: GREEN } }
			}}
		>
			{tabs.map((tab, index) => (
				<Tab
					key={tab.id}
					value={index}
					iconPosition='end'
					label={<p className='medium10'>{tab.value}</p>}
					icon={
						<Chip
							label={documentCounts?.[countMappingNames[tab.value]?.name] || 0}
							size='small'
							style={{
								backgroundColor: countMappingNames[tab.value]?.color
							}}
						/>
					}
				/>
			))}
		</Tabs>

		{/* Actions */}
		<Box
			sx={{
				display: 'flex',
				alignItems: 'center',
				gap: 1,
				flexShrink: 0
			}}
		>
			<CustomDropdown
				value={selectedDropdownValue}
				onChange={handleDropdownChange}
				startDate={startDate}
				endDate={endDate}
			/>

			{dropdowns?.[tabs[selectedTab]?.keyName]?.length && (
				<Tooltip title='Status Filters' arrow>
					<Badge
						badgeContent={statusFilter.length}
						color='error'
						overlap='circular'
						invisible={statusFilter.length === 0}
						sx={{
							'& .MuiBadge-badge': {
								fontSize: '0.7rem',
								minWidth: 18,
								height: 18,
								borderRadius: '50%',
								top: 6,
								right: 6
							}
						}}
					>
						<IconButton
							onClick={handleFilterClick}
							sx={{
								bgcolor: '#b8d524',
								borderRadius: '8px',
								height: '36px',
								width: '49px',
								':hover': {
									bgcolor: '#b8d524'
								}
							}}
						>
							<FilterListIcon />
						</IconButton>
					</Badge>
				</Tooltip>
			)}

			<Box
				component='img'
				src={DownloadIcon}
				alt='Download Icon'
				sx={{
					cursor: 'pointer',
					width: '50px',
					height: '40px',
					mx: 1
				}}
				onClick={handleDownloadModal}
			/>

			<RenderMenu
				anchorEl={downloadAnchor}
				open={open}
				handleClose={handleClose}
				itemMenu={itemMenu}
			/>
		</Box>
	</Box>
);

TabHeader.propTypes = {
	isMobile: PropTypes.bool.isRequired,
	tabs: PropTypes.array.isRequired,
	selectedTab: PropTypes.number.isRequired,
	handleTabChange: PropTypes.func.isRequired,
	documentCounts: PropTypes.object,
	countMappingNames: PropTypes.object,
	selectedDropdownValue: PropTypes.any,
	handleDropdownChange: PropTypes.func,
	startDate: PropTypes.any,
	endDate: PropTypes.any,
	statusFilter: PropTypes.array,
	handleFilterClick: PropTypes.func,
	handleDownloadModal: PropTypes.func,
	downloadAnchor: PropTypes.any,
	open: PropTypes.bool,
	handleClose: PropTypes.func,
	itemMenu: PropTypes.array
};

export default TabHeader;
